module.exports = "/_next/static/images/8c5e1848cbe92036bcf9f137744901f9-right-side-mobile.jpg";